import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import { push } from "react-router-redux";

import { Logo } from "../../../core/atoms";
import LoginForm from "../../../shared/components/authentication/loginForm";
import { apiPromiseHook } from "../../../shared/flux/actions/enterHooks";
import { EnterHookPromises } from "../../state/enterHookPromises";
import { RoutesInvoker } from "./../../routesInvoker";
import { ActionPromises } from "./../../state/actionPromises";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { GoogleAnalyticsHelper } from "@travellocal/ui";

import "./login.scss";

interface StateProps {
  routing?: any;
}

interface DispatchProps {
  login: (loginRequest: ILoginRequest) => DispatchedPromise<ILoginResponse>;
  logout: () => void;
  navigate: (uri: string) => void;
}

interface State {
  email?: string;
  password?: string;
  errorMessage?: string;
}

type Props = StateProps & DispatchProps;

export class LoginComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  private login = async (email: string, password: string) => {
    const request: ILoginRequest = {
      username: email,
      password,
    };

    const loginResult = await this.props.login(request);
    const loginResponse = loginResult.value;

    // Redirect admins and ltos to portal
    if (loginResponse.user.userType !== UserType.Customer) {
      GoogleAnalyticsHelper.logEvent("Login", "Response", "Login redirect");
      await this.props.logout();
      location.href = `${globalConfig.appBaseUrl}/account/login#token=${loginResponse.token}&expires=${loginResponse.expires}`;
      return;
    }

    GoogleAnalyticsHelper.logEvent("Login", "Response", "Login success");
    this.props.navigate(RoutesInvoker.customerIndex);
  }

  public render() {

    const { routing } = this.props;
    const displayLoggedOutReason: string | undefined = routing?.locationBeforeTransitions?.query?.loggedOutReason;

    // tslint:disable:max-line-length

    return (
      <div className="web-login">
        <Helmet title="Log in to TravelLocal" />

        <div className="wrap">
          <Logo type="accent" link="/" width={96} />

          <h1>Sign in to TravelLocal</h1>

          {displayLoggedOutReason != null &&
            <h2>{displayLoggedOutReason}</h2>
          }

          <p><strong>If you've made an enquiry</strong>, then you have a TravelLocal account. To plan or book your holiday, enter your account details below.</p>

          <LoginForm login={(email, pass) => this.login(email, pass)} />

          <hr />

          <p><Link to={RoutesInvoker.forgottenPassword()}>Click here if you don't know your password</Link></p>

          <p>
            If you're having difficulties signing in, you can call us on <strong>+44 (0)117 325 7898</strong> or email us at <a href="mailto:team@travellocal.com">team@travellocal.com</a>
          </p>
          <hr/>
          <p><strong>Not made an enquiry? </strong> We've partnered with <Link to={WebRoutes.destinations()}>experts in over 40 countries</Link> to help you <Link to={WebRoutes.enquiryForm({ campaign: "signin" })}> plan your dream holiday</Link>. <Link to={WebRoutes.aboutHome()}> Find out more about TravelLocal here.</Link></p>

          <p><Link to={WebRoutes.index()}>Back to TravelLocal.com</Link></p>

        </div>

        <div className="image-bg" />
      </div>
    );
  }
}

const mapStateToProps = (state: IAppStoreState): StateProps => {
  return {
    routing: state.routing,
  };
};

const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    logout: () => dispatch(ActionPromises.logout()),
    login: (loginRequest: ILoginRequest) => dispatch(ActionPromises.login(loginRequest)),
    navigate: (route: string) => dispatch(push(route)),
  };
};

export const Login = connect(mapStateToProps, mapDispatchToProps)(LoginComponent);

export const LoginOnEnter = apiPromiseHook<any>(
  EnterHookPromises.logoutIfRequested(),
);
